module.exports = __webpack_public_path__ + "static/media/desktop14.aaebc1f8.png";